var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 916,
    height: 950,
    viewBox: "0 0 916 950",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M457.976 948.299C709.956 948.299 914.226 736.406 914.226 475.018C914.226 213.63 709.956 1.73315 457.976 1.73315C205.997 1.73315 1.72656 213.63 1.72656 475.018C1.72656 736.406 205.997 948.299 457.976 948.299Z",
    stroke: "url(#paint0_linear_5_439)",
    strokeWidth: 1.62581,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_439",
    x1: 457.936,
    y1: 1.24627,
    x2: 457.936,
    y2: 948.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#161A24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#161A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161A24",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector-1.32521ee363540ff458221a8c6a0903a7.svg";
export { ForwardRef as ReactComponent };